
/* styles */
require("!!../../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5ab12ad6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=styles&index=0!./MobileVideoFace.vue")

var Component = require("!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./MobileVideoFace.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5ab12ad6\"}!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./MobileVideoFace.vue"),
  /* scopeId */
  "data-v-5ab12ad6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/baiDuFace/MobileVideoFace.vue
// module id = 1117
// module chunks = 41